import head from 'lodash/head';
type RemoveQueryParams = (url: string) => string;

export const removeQueryParams: RemoveQueryParams = (url) => head(url.split('?')) || '';
